import { StyleControlOptions } from './form-control-options';
export class SequenceNoOptions extends StyleControlOptions {
    constructor() {
        super(...arguments);
        /**
         * 流水号编码
         */
        this.prefix = null;
        /**
         * 最大长度
         */
        this.maxLength = '6';
        /**
         * 重置策略时间 'none' | 'year' | 'month' | 'week' | 'day'
         */
        this.resetDate = 'YEAR';
        /**
         * 连接符 '-' | '#' | '、' | '_' |
         */
        this.delimiter = 'mark1';
    }
}
/**
 * 创建时间
 */
export class CreatedTimeOptions extends StyleControlOptions {
    constructor() {
        super(...arguments);
        this.format1 = "YYYY-MM-DD HH:mm:ss";
        this.format = 'YYYY-MM-DD HH:mm:ss';
    }
}
